import React from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./content/report-content.jsx";

const Content = ({reportData, data, showMap, showLayer, mapMode, entity, title, collapsed, printComponentRef, setLoading, mapImage}) => {
    return (
        <>
            {
                reportData && data > 0 && (
                    <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setLoading} customSubTitle={reportData?.garrisonName} landscape={true}>
                        <div id="filters-print" className={'transform !-translate-y-[8.5px]'}></div>
                        <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>

                        { mapImage && (
                            <div id="map-image-container" className="print:block">
                                <img src={mapImage} style={{ width: "100%", height: "854px" }}  alt={'Mapa'}/>
                            </div>
                        )}

                        <div className={"mt-[25px] print:mt-[0] print:hidden"}>
                            { showMap && (
                                <ReportContent
                                    data={reportData}
                                    collapsed={collapsed}
                                    showLayer={showLayer}
                                    mapMode={mapMode}
                                    mapImage={mapImage}
                                />
                            )}
                        </div>
                    </PrintTemplate>
                )
            }
        </>
    );
};

export default Content;